export default {
  title: 'Lisää kumppani',
  mode: {
    single: 'Yksittäinen kumppani',
    bulk: 'Massatuonti (CSV)',
  },
  buttons: {
    send_invite: 'Lähetä kutsu',
  },
  bulk: {
    form: {
      file: {
        label: 'Kumppaniluettelo (CSV)',
        hint: 'Yksi kumppani per rivi. Pakolliset sarakkeet: Email, Company country, ja Registered company name tai Company name. Brand name on valinnainen ja siitä tulee kuluttajille näkyvä nimi. Jokainen rivi tarkistetaan ennen kuin mitään luodaan.',
      },
    },
    buttons: {
      select_file: 'Valitse CSV-tiedosto',
      download_template: 'Lataa tuontimalli',
      import: 'Tuo kumppanit',
    },
    columns: {
      legal_name: 'Rekisteröity yrityksen nimi / Yrityksen nimi',
      display_name: 'Brändin nimi',
      admin_email: 'Sähköposti',
      company_country: 'Yrityksen maa',
    },
    errors: {
      title: 'Tiedostoa ei voitu tuoda.',
      nothing_imported: 'Yhtään kumppania ei luotu. Korjaa yllä olevat rivit ja lataa tiedosto uudelleen.',
      columns: {
        row: 'Rivi',
        column: 'Sarake',
        error: 'Virhe',
      },
    },
    toasts: {
      queued_one:
        '{{count}} kumppani jonossa — kutsut lähetetään sitä mukaa kun kukin luodaan. Saat yhteenvetosähköpostin, kun tuonti on valmis.',
      queued_other:
        '{{count}} kumppania jonossa — kutsut lähetetään sitä mukaa kun kukin luodaan. Saat yhteenvetosähköpostin, kun tuonti on valmis.',
    },
    footnote:
      'Kumppanit luodaan taustalla yksi kerrallaan samalla tavalla kuin yksittäinen kumppani: kutsusähköposti, hallintapaneelin aliverkkotunnus ja oletusverkkokaupan verkkotunnus. Maa määrittää valuutan ja aikavyöhykkeen; osavaltion voi asettaa myöhemmin kumppanin profiilista. Maksujen käsittely määritetään jälkikäteen kunkin kumppanin Maksut-välilehdellä.',
  },
  form: {
    name: {
      label: 'Kumppanin nimi',
    },
    admin_email: {
      label: 'Ylläpitäjän sähköposti (kutsun vastaanottaja)',
      hint: 'Lähetämme sähköpostitse kutsun tilin perustamiseen.',
    },
    display_name: {
      label: 'Kuluttajille näkyvä nimi',
      hint: 'Asiakkaille näytettävä ”Powered by ___” -teksti. Oletuksena kumppanin nimi, jos jätetään tyhjäksi.',
    },
    region: {
      label: 'Maa',
      placeholder: 'Valitse maa',
      hint: 'Määrittää kumppanin valuutan, aikavyöhykkeen ja kutsun kielen.',
      summary: 'Valuutta {{currency}} · {{timezone}} · Kutsun kieli {{language}}',
      default_root: 'Verkkokaupan verkkotunnus: uudet brändit tarjoillaan osoitteessa {{host}}',
    },
    sub_region: {
      label: 'Osavaltio',
      placeholder: 'Koko maa',
      hint: 'Valinnainen — jätä tyhjäksi, jos koskee koko maata.',
    },
    language: {
      label: 'Kutsun kieli',
      placeholder: '{{language}} (oletus)',
      hint: 'Valinnainen — oletuksena maan pääkieli.',
    },
  },
  footnote: 'Brändäys ja ansainta-asetukset voidaan määrittää sen jälkeen, kun kumppani on hyväksynyt kutsunsa.',
  toasts: {
    created: 'Kumppani luotu — kutsusähköposti on matkalla.',
  },
};
